// Observe Recharge subscription widget and add text
document.addEventListener('DOMContentLoaded', function() {
  // Create a MutationObserver to watch for the Recharge widget
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Check if this is the recharge-subscription-widget or contains it
            const rechargeWidget = node.querySelector('.recharge-subscription-widget') || 
                                  (node.classList && node.classList.contains('recharge-subscription-widget') ? node : null);
            
            if (rechargeWidget) {
              // Wait a bit for the widget to fully load
              setTimeout(function() {
                addPauseCancelText();
                observeSellingPlansChanges();
              }, 1000);
            }
          }
        });
      }
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Function to add the "Pause or cancel anytime" text
  function addPauseCancelText() {
    const subscriptionRadios = document.querySelectorAll('.subscription-radio');
    
    subscriptionRadios.forEach(function(radio) {
      // Check if text already exists to avoid duplicates
      if (!radio.querySelector('.pause-cancel-text')) {
        // Get text from rc-selling-plans-single
        const sellingPlansSingle = document.querySelector('.rc-selling-plans .rc-selling-plans-single');
        const sellingPlansText = sellingPlansSingle ? sellingPlansSingle.textContent : '';
        
        // Create paragraph with class mmm and selling plans text
        const mmmText = document.createElement('p');
        mmmText.className = 'period-text';
        mmmText.textContent = sellingPlansText;
        
        // Create pause text
        const pauseText = document.createElement('p');
        pauseText.className = 'pause-cancel-text light-text';
        pauseText.innerHTML = `
        <p>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 7H13H18.79C19.9733 7 20.8978 8.02164 20.7801 9.19901L20.1801 15.199C20.0779 16.2214 19.2175 17 18.19 17H8.63961C7.68625 17 6.86542 16.3271 6.67845 15.3922L5 7Z" stroke="#2D3E40" stroke-width="2" stroke-linejoin="round"/>
        <path d="M5 7L4.18937 3.75746C4.07807 3.3123 3.67809 3 3.21922 3H2" stroke="#2D3E40" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8 21H10" stroke="#2D3E40" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16 21H18" stroke="#2D3E40" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span><strong>One Time Purchase: </strong>Showerhead + 1 Filter</span>
        </p>
        <p>
        <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 0V2H2C0.89 2 0 2.89 0 4V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H8.1C9.36 21.24 11.09 22 13 22C16.87 22 20 18.87 20 15C20 13.09 19.24 11.36 18 10.1V4C18 3.46957 17.7893 2.96086 17.4142 2.58579C17.0391 2.21071 16.5304 2 16 2H15V0H13V2H5V0M2 4H16V6H2M2 8H16V8.67C15.09 8.24 14.07 8 13 8C9.13 8 6 11.13 6 15C6 16.07 6.24 17.09 6.67 18H2M13 10.15C15.68 10.15 17.85 12.32 17.85 15C17.85 17.68 15.68 19.85 13 19.85C10.32 19.85 8.15 17.68 8.15 15C8.15 12.32 10.32 10.15 13 10.15ZM12 12V15.69L15.19 17.53L15.94 16.23L13.5 14.82V12H12Z" fill="#2D3E40"/>
        </svg>

        <span><strong>Every 30 days: </strong>Replacement Filter</span>
        </p>
        <span>Pause or cancel anytime</span>
          
        `;

        // Add mmm text first, then pause text
        // radio.appendChild(mmmText);
        radio.appendChild(pauseText);

      }
    });
  }

  // Function to update text when selling plans change
  function updateSellingPlansText() {
    const subscriptionRadios = document.querySelectorAll('.subscription-radio');
    
    subscriptionRadios.forEach(function(radio) {
      const periodText = radio.querySelector('.period-text');
      if (periodText) {
        const sellingPlansSingle = document.querySelector('.rc-selling-plans .rc-selling-plans-single');
        const sellingPlansText = sellingPlansSingle ? sellingPlansSingle.textContent : '';
        periodText.textContent = sellingPlansText;
      }
    });
  }

  // Function to observe selling plans changes
  function observeSellingPlansChanges() {
    const sellingPlansObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          // Check if rc-selling-plans-single content changed
          const sellingPlansSingle = document.querySelector('.rc-selling-plans .rc-selling-plans-single');
          if (sellingPlansSingle) {
            setTimeout(function() {
              updateSellingPlansText();
            }, 100);
          }
        }
      });
    });

    // Observe the entire Recharge widget for changes
    const rechargeWidget = document.querySelector('.recharge-subscription-widget');
    if (rechargeWidget) {
      sellingPlansObserver.observe(rechargeWidget, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  // Also check if widget is already present on page load
  if (document.querySelector('.recharge-subscription-widget')) {
    setTimeout(function() {
      addPauseCancelText();
      observeSellingPlansChanges();
    }, 1000);
  }
});
